import { useCallback, useEffect, useState, Fragment } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Toast from "helper/toast";
import { Grid } from "@mui/material";
import {
  StyledPaper,
  StyledButton,
  StyledDivButton,
  StyledTitle,
  StyledDivIcon,
  StyledDivtext,
  StyledGrid,
  StyledLink,
} from "./Complaint.style";
import ContactCM from "components/contactus";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import { addComplaintMessageRequest } from "api/requests";
import LoadingCM from "components/shared/Loading";
import TextField from "@mui/material/TextField";
import useHttp from "hooks/use-http";
import Container from "@mui/material/Container";
import { complaintSchema } from "validations";
import MenuCM from "components/shared/menu";
import Alert from "@mui/material/Alert";
import FooterCM from "components/shared/footer";
import {Helmet} from "react-helmet";

export default function Complaint() {
  const { request, loading, setLoading } = useHttp(false);
  const [contact, setContact] = useState([]);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(complaintSchema),
  });

  const onSubmit = async (values) => {
    setLoading(true);
    const res = await request({
      url: addComplaintMessageRequest,
      values,
    });
    if (res) {
      setLoading(false);
      reset({
        full_name: "",
        email: "",
        message: "",
        subject: "",
        phone_number: "",
      });
      Toast({ type: "success", title: "ثبت شکایت" });
    }
  };

  return (
    <div>
      <Helmet>
        <title>ثبت شکایت - مبلمان ویول</title>
        <meta name="product_id" content={""} />
        <meta name="product_name" content={""} />
        <meta name="product_price" content={""} />
        <meta name="product_old_price" content={""} />
        <meta name="availability" content={""} />
        <meta property="og:image" content={""} />
      </Helmet>
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <MenuCM pageTitle="ثبت شکایت" />
          <Container>
            <Grid container spacing={2}>
              <Grid item md={12} xs={12}>
                <StyledPaper elevation={3}>
                  <Grid container>
                    <Grid
                      item
                      md={1}
                      xs={12}
                      sx={{ padding: "0 !important" }}
                    ></Grid>
                    <Grid
                      item
                      md={10}
                      xs={12}
                      mb={2}
                      sx={{ padding: "0 !important" }}
                    >
                      <Grid container spacing={2}>
                        <Grid
                          item
                          xs={12}
                          mb={2}
                          sx={{ padding: "0 !important" }}
                        >
                          <StyledTitle>فرم ثبت شکایت</StyledTitle>
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <TextField
                            label="نام و نام خانوادگی"
                            defaultValue=""
                            size="small"
                            id="full_name"
                            {...register("full_name")}
                            error={Boolean(errors.full_name)}
                            helperText={errors.full_name?.message}
                            fullWidth
                          />
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <TextField
                            label="ایمیل"
                            defaultValue=""
                            size="small"
                            id="email"
                            {...register("email")}
                            error={Boolean(errors.email)}
                            helperText={errors.email?.message}
                            fullWidth
                          />
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <TextField
                            label="تلفن همراه"
                            defaultValue=""
                            size="small"
                            id="phone_number"
                            {...register("phone_number")}
                            error={Boolean(errors.phone_number)}
                            helperText={errors.phone_number?.message}
                            fullWidth
                          />
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <TextField
                            label="موضوع شکایت"
                            defaultValue=""
                            size="small"
                            id="subject"
                            {...register("subject")}
                            error={Boolean(errors.subject)}
                            helperText={errors.subject?.message}
                            fullWidth
                          />
                        </Grid>
                        <Grid item md={12} xs={12}>
                          <TextField
                            label="شرح شکایت"
                            defaultValue=""
                            multiline
                            rows={5}
                            id="message"
                            {...register("message")}
                            error={Boolean(errors.message)}
                            helperText={errors.message?.message}
                            fullWidth
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    md={1}
                    xs={12}
                    sx={{ padding: "0 !important" }}
                  ></Grid>

                  <StyledDivButton>
                    <StyledButton
                      variant="contained"
                      onClick={handleSubmit(onSubmit)}
                    >
                      ثبت شکایت
                    </StyledButton>
                  </StyledDivButton>
                </StyledPaper>
              </Grid>
            </Grid>
          </Container>
          <ContactCM All />
          <FooterCM />
        </Fragment>
      )}
    </div>
  );
}
